<template>
    <div class="shareExperience">
        <!-- 点击我想要这份礼服跳转share-experience -->
        <div class="step_title">
            <p><span>Step 1 of 4:</span>A Survey About Your Purchase</p>
             <el-progress :text-inside="true" :stroke-width="24" :percentage="25" status="success"></el-progress>
        </div>
        <div class="post-content">
            <div class="post-content-left">
                <div class="fusion-title">{{title}}</div>
                <img :src="image" alt="" style="width: 200px;">
            </div>
            <el-card class="box-card">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm" label-width="auto"  label-position="top">
                    <el-form-item label="I Am A..." prop="sex">
                            <el-radio-group v-model="ruleForm.sex">
                                <el-radio label="Male"></el-radio>
                                <el-radio label="Female"></el-radio>
                                <el-radio label="I don't want to tell you"></el-radio>
                            </el-radio-group>
                    </el-form-item>
                    <el-form-item label="What's Your Age?" prop="age">
                        <el-radio-group v-model="ruleForm.age">
                            <el-radio label="Less than 20"></el-radio>
                            <el-radio label="20-29"></el-radio>
                            <el-radio label="30-49"></el-radio>
                            <el-radio label="40-49"></el-radio>
                            <el-radio label="50-59"></el-radio>
                            <el-radio label="More than 59"></el-radio>
                            <el-radio label="I don't want to tell you"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="How Long Have You Used Our Product?" prop="productServiceTime">
                        <el-radio-group v-model="ruleForm.productServiceTime">
                            <el-radio label="Less Than 10 Days"></el-radio>
                            <el-radio label="10-30 Days"></el-radio>
                            <el-radio label="More Than 30 Days"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="Why Do You Choose Our Product?" prop="causes">
                        <el-checkbox-group v-model="ruleForm.causes">
                            <el-checkbox label="Brand" name="type"></el-checkbox>
                            <el-checkbox label="Design" name="type"></el-checkbox>
                            <el-checkbox label="Price" name="type"></el-checkbox>
                            <el-checkbox label="Function" name="type"></el-checkbox>
                            <el-checkbox label="Customer Reviews" name="type"></el-checkbox>
                            <el-checkbox label="Just A Random Choice" name="type"></el-checkbox>
                            <el-checkbox label="Other Reason" name="type"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">Next Step</el-button>
                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
    </div>
</template>
<script>
import {freeGiftOrderTow} from '../../../api/freeGift'
export default {
    data() {
        return {
            title:'',
            ruleForm:{
                sex:'',
                age:'',
                productServiceTime:'',
                // cause:[],
                causes:[],
                cause:'',
                amazonOrderId:'',
            },
            rules:{
                sex: [
                    { required: true, message: '请选择性别', trigger: 'change' }
                ],
                age: [
                    { required: true, message: '请选择年龄', trigger: 'change' }
                ],
                productServiceTime: [
                    { required: true, message: '请选择产品使用时长', trigger: 'change' }
                ],
                causes: [
                    { type: 'array', required: true, message: '选择我们产品的原因', trigger: 'change' }
                ],
            },
            img_url:'',
            image:''
        }
    },
    methods:{
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    sessionStorage.share1sex = this.ruleForm.sex;
                    sessionStorage.share1age = this.ruleForm.age;
                    sessionStorage.share1product_service_time = this.ruleForm.productServiceTime;
                    sessionStorage.share1causes = this.ruleForm.causes;
                    // 将数组转成字符串
                    this.ruleForm.cause = this.ruleForm.causes.toString();
                    delete this.ruleForm.causes;
                    freeGiftOrderTow(this.ruleForm).then((res=>{
                        if (res.data.code === 200) {
                            this.$message.success(res.data.message);
                            // 跳转到下一步
                            this.$router.push(
                                {
                                    path:'/share-experience-2',
                                    query:{amazonOrderId:res.data.data.amazonOrderId,image:this.image,title:this.title}
                                }
                            )
                            this.$refs[formName].resetFields();
                        }else if(res.data.code === 201){
                            this.$router.push('/noOrderId')
                        }
                        else {
                            this.$message(res.data.message);
                        }
                    }))
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.ruleForm.sex = '';
            this.ruleForm.age = '';
            this.ruleForm.productServiceTime = '';
            this.ruleForm.causes = [];
            // if(sessionStorage.share1sex){
            //     sessionStorage.removeItem('share1sex');
            // }
            // if(sessionStorage.share1age){
            //     sessionStorage.removeItem('share1age');
            // }
            // if(sessionStorage.share1product_service_time){
            //     sessionStorage.removeItem('share1product_service_time');
            // }
            // if(sessionStorage.share1causes){
            //     sessionStorage.removeItem('share1causes');
            // }
        }
    },
    created(){
        this.ruleForm.amazonOrderId = this.$route.query.amazonOrderId;
        this.img_url = this.$route.query.img_url;
        this.title = this.$route.query.title;
        this.image = this.$route.query.image;
        if(sessionStorage.share1sex){
            this.ruleForm.sex = sessionStorage.share1sex;
        }
         if(sessionStorage.share1age){
            this.ruleForm.age = sessionStorage.share1age;
        }
         if(sessionStorage.share1product_service_time){
            this.ruleForm.productServiceTime = sessionStorage.share1product_service_time;
        }
        if(sessionStorage.share1causes){
            this.ruleForm.causes = sessionStorage.share1causes.split(",");
        }
    },
    activated() {
    // if (!this.$route.meta.isBack) { //true执行
    // // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
    // //清空表单
    
    // }
    // // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    // this.$route.meta.isBack = false;
    },
    beforeRouteLeave(to,from,next){
        // console.log(to.path);
      if(
          to.path == '/gift' || 
          to.path == '/warranty-activated' ||
          to.path == '/share-experience' ||
          to.path == 'share-experience-2' ||
          to.path == 'share-experience-3' ||
          to.path == 'share-experience-4'
          ){
            //缓存
          from.meta.keepAlive = true;
      }else{
            //不缓存
          from.meta.keepAlive = false ;
      }
      next()
  }
}
</script>
<style lang="less" scoped>
    .shareExperience{
        padding: 0px 30px;
        width: 70%;
        margin: 0 auto;
        padding-bottom: 50px;
        box-sizing: border-box;
       .step_title{
           margin-top: 20px;
           margin-bottom: 20px;
           p{
               font-size: 18px;
               color: #393838;
               line-height: 26px;
               margin-bottom: 10px;
               span{
                   color: #a099cb;
                   margin-right: 5px;
               }
           }
       }
       .post-content{
           display: flex;
           justify-content: space-around;
           margin-bottom: 30px;
           .post-content-left{
               width: 380px;
               margin-right: 4%;
               .fusion-title{
                   color: rgb(239, 129, 163);
                   font-size: 18px;
                   line-height: 26px;
                   font-weight: bold;
                   margin-bottom: 30px;
               }
           }
           .el-card{
              flex: 1;
           }
       }
    }
</style>